



























































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  DamageModel,
  DamageRegulationType,
  DamageStatus,
  IDamage,
  ITag,
  IUser,
  normalizeDamageRegulationType,
  TagCategory,
} from 'admiral-core';
import { XIcon, ListIcon } from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormMixin } from '@/mixins/FormMixin';
import { DamageApi } from '@/services/DamageApi';
import { TagApi } from '@/services/TagApi';
import DamageForm from '@/forms/DamageForm.vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import { BModal } from 'bootstrap-vue';
import DamageTimeline from '@/views/pages/damages/DamageTimeline.vue';
import confetti from 'canvas-confetti';
import { PermissionMixin } from '@/mixins/PermissionMixin';

import { FlixcheckApi } from '@/services/integrations/FlixcheckApi';

@Component({
  name: 'edit-damage-modal',
  components: {
    DamageTimeline,
    DamageForm,
    FormSubmit,
    XIcon,
    ListIcon,
  },
})
export default class EditDamageModal extends mixins(BaseMixin, FormMixin, PermissionMixin) {
  @Prop({ required: false, type: Object })
  selectedDamage!: IDamage | null;

  tags: ITag[] = [];
  model = this.defaultModel();
  isContentHovered = false;
  isArchiving = false;

  defaultModel(): DamageModel {
    return {
      ...(this.selectedDamage || {
        customer: '',
        regulationType: DamageRegulationType.CENTRAL,
      }),
      newUploadedFiles: [],
      newComments: [],
      integrationFlixcheckChecks: [],
    } as DamageModel;
  }
  async mounted() {
    // this.model.user = this.user;

    this.$root.$on('bv::modal::show', async (_e: Event, modalId: string) => {
      if (modalId === 'edit-damage') {
        await this.loadTags();
        await this.loadTasks();
        await this.loadFlixcheckChecks();
      }
    });

    this.model = { ...this.defaultModel() };
  }

  beforeDestroy() {
    this.$root.$off('bv::modal::show');
    this.unsubscribeFromEntityFiles();
  }

  @Watch('selectedDamage', { immediate: true })
  async watchSelectedDamage() {
    if (!this.selectedDamage) return;

    const user = this.selectedDamage.user || ({ id: '' } as IUser);

    this.model = {
      ...this.selectedDamage,
      regulationType:
        normalizeDamageRegulationType(this.selectedDamage.regulationType) ??
        DamageRegulationType.CENTRAL,
      user: user,
      damageSteps: [],
      tasks: this.selectedDamage.tasks || [],
      newUploadedFiles: [],
      newComments: [],
      integrationFlixcheckChecks: [],
    };
    await this.loadDamageSteps();
    this.unsubscribeFromEntityFiles();
    this.subscribeToEntityFiles();
  }

  async loadFiles() {
    const files = await DamageApi.getFiles(this.model.id!);
    this.model.files = files.data;
  }

  async loadDamageSteps() {
    try {
      const damageSteps = await DamageApi.getDamageSteps(this.model.id!);
      this.model.damageSteps = damageSteps.data;
    } catch (e) {
      console.log(e);
    }
  }

  async loadTasks() {
    try {
      const tasks = await DamageApi.getTasks(this.model.id!);
      this.model.tasks = tasks.data;
    } catch (e) {
      console.log(e);
    }
  }

  async loadFlixcheckChecks() {
    if (this.hasAgencyPermission('flixcheck') && this.model.id) {
      const checks = await FlixcheckApi.getDamageChecks(this.model.id!);
      this.model = {
        ...this.model,
        integrationFlixcheckChecks: checks.data,
      };
    }
  }

  async ok(evt: Event) {
    if (!this.model?.id) return;
    evt.preventDefault();

    try {
      this.isLoading = true;

      // Validierung: Customer ist required
      if (!this.model.customer || this.model.customer.trim() === '') {
        this.addError(true, 'customer', 'Bitte geben Sie einen Kunden an');
        this.isLoading = false;
        return;
      }

      const status = this.model.status;

      // Behandeln Sie den Fall, wenn user nicht zugewiesen ist
      let userToSend: IUser | undefined = this.model.user;
      if (!userToSend || !userToSend.id || userToSend.id === '') {
        userToSend = undefined; // Verwenden Sie undefined statt null
      }

      const damageForm = this.$refs['damage-form'] as DamageForm;
      const commentBox = damageForm.$refs['commentbox'] as any;
      if (commentBox.value?.text) {
        this.model.newComments!.push({
          id: 'new-comment',
          text: commentBox.value?.text,
          createdAt: new Date(),
          updatedAt: new Date(),
          user: this.user!,
          isDemo: false,
        });
        commentBox.resetComment();
      }

      const updatedDamage = await DamageApi.update(this.model.id, {
        agency: this.agency,
        customer: this.model.customer,
        product: this.model.product,
        policyNumber: this.model.policyNumber,
        affectedItem: this.model.affectedItem,
        location: this.model.location,
        value: this.model.value ? Number(this.model.value) : undefined,
        date: this.model.date,
        description: this.model.description,
        dueAt: this.model.dueAt,
        regulationType:
          normalizeDamageRegulationType(this.model.regulationType) ?? DamageRegulationType.CENTRAL,
        user: userToSend, // Verwenden Sie die bereinigte Version
        tags: this.model.tags || [],
        tasks: this.model.tasks || [],
        important: this.model.important || false,
        updatedBy: this.user,
        status: this.model.status,
        newUploadedFiles: this.model.newUploadedFiles || [],
        files: this.model.files || [],
      });

      if (this.selectedDamage?.status !== status && status === DamageStatus.COMPLETED) {
        setTimeout(() => {
          confetti();
        }, 200);
      }

      // Emittieren Sie das aktualisierte Damage-Objekt
      this.$emit('reload');
      this.$emit('update-task', updatedDamage.data);

      this.$nextTick(() => {
        (this.$refs['edit-damage'] as BModal).hide();
        this.$emit('closed');
      });

      this.$toastr.s(
        `Schaden für ${this.model.customer} erfolgreich aktualisiert.`,
        'Schaden gespeichert',
      );
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);
      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Schadens ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['customerisNotEmpty'], 'customer', 'Kunde angeben.');
  }

  cancel() {
    this.$emit('closed');
  }

  async confirmDeletion() {
    try {
      if (!this.model.id || !this.selectedDamage) {
        this.$toastr.e('Schaden-ID nicht gefunden.');
        return;
      }

      await DamageApi.delete(this.model.id, {
        damage: this.selectedDamage,
      });

      // Schließe beide Modals
      this.$bvModal.hide('modal-delete');
      (this.$refs['edit-damage'] as BModal).hide();

      this.$emit('reload');
      this.$emit('closed');

      this.$toastr.s(
        `Schaden für ${this.model.customer} erfolgreich gelöscht.`,
        'Schaden gelöscht',
      );
    } catch (e) {
      console.error('Error deleting damage:', e);
      this.$toastr.e('Beim Löschen des Schadens ist etwas schief gelaufen.');
    }
  }

  get canArchive(): boolean {
    return (
      this.model.status === DamageStatus.COMPLETED || this.model.status === DamageStatus.DECLINED
    );
  }

  async archiveDamage() {
    try {
      if (!this.model.id) {
        this.$toastr.e('Schaden-ID nicht gefunden.');
        return;
      }

      this.isArchiving = true;

      await DamageApi.archiveDamage(this.model.id);

      (this.$refs['edit-damage'] as BModal).hide();

      this.$emit('reload');
      this.$emit('closed');

      this.$toastr.s(
        `Schaden für ${this.model.customer} erfolgreich archiviert.`,
        'Schaden archiviert',
      );
    } catch (e) {
      console.error('Error archiving damage:', e);
      this.$toastr.e('Beim Archivieren des Schadens ist etwas schief gelaufen.');
    } finally {
      this.isArchiving = false;
    }
  }

  async dearchiveDamage() {
    try {
      if (!this.model.id) {
        this.$toastr.e('Schaden-ID nicht gefunden.');
        return;
      }

      this.isArchiving = true;

      await DamageApi.dearchiveDamage(this.model.id);

      (this.$refs['edit-damage'] as BModal).hide();

      this.$emit('reload');
      this.$emit('closed');

      this.$toastr.s(
        `Archivierung für ${this.model.customer} erfolgreich aufgehoben.`,
        'Archivierung aufgehoben',
      );
    } catch (e) {
      console.error('Error dearchiving damage:', e);
      this.$toastr.e('Beim Aufheben der Archivierung ist etwas schief gelaufen.');
    } finally {
      this.isArchiving = false;
    }
  }

  async loadTags() {
    try {
      const { data } = await TagApi.getTags({
        agency: this.user.agency,
        category: TagCategory.Damages,
      });
      this.tags = data;
    } catch (e) {
      console.error(e);
    }
  }
  subscribeToEntityFiles() {
    const topic = 'damage-files-updated-' + this.model.id;
    this.$store.dispatch('socketConnection/subscribeToTopic', {
      topic: topic,
      eventName: 'damage-files-updated',
      handler: (data: any) => {
        this.loadFiles();
      },
    });
  }
  unsubscribeFromEntityFiles() {
    this.$store.dispatch('socketConnection/unsubscribeFromTopic', {
      topic: 'damage-files-updated-' + this.model.id,
      eventName: 'damage-files-updated',
    });
  }
}
